var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',[_vm._m(0),_c('tbody',_vm._l((_vm.offices),function(office,i){return _c('tr',{key:i,staticClass:"office-row"},[_c('td',[_vm._v(" "+_vm._s(office['id'])+" ")])])}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_c('th',[_vm._v("Office #")])])])
}]

export { render, staticRenderFns }